module.exports = __webpack_public_path__ + "static/media/btn_edit_right.a2f9d849.svg";